<script>
  export let href;

  function openSmallWindow() {
    window.open(href, "name", "width=600,height=400");
  }

</script>

<li>
  <a {href} class="fizz-social-icon" rel="noopener" target="popup" on:click={openSmallWindow}>
    <slot />
  </a>
</li>
